import { render, staticRenderFns } from "./TrailerLastUpdateDisplay.vue?vue&type=template&id=fa4c211a"
import script from "./TrailerLastUpdateDisplay.vue?vue&type=script&lang=js"
export * from "./TrailerLastUpdateDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports